import { Injector } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { PwaService } from './pwa/pwa.service';

export function appInitializerFactory(injector: Injector) {
  return () => {
    return new Promise<boolean>((resolve, reject) => {
      const authService = injector.get(AuthService);
      const pwaService = injector.get(PwaService);

      pwaService.init();

      // Restoration failure is handled locally by AuthService; it is not an explicit sign-out.
      authService.init().then(() => {
        resolve(true);
      }).catch(() => {
        resolve(true);
      });
    });
  };
}
